import {Fragment, UUID} from '@nh/angular-tses';
import {DASFragmentType} from './das-fragment-type';

/**
 * A class representing a HTML Fragment used for displaying DAS 2.0 free text sections.
 *
 * @field value {string}   The raw HTML
 */
export class HTMLFragment extends Fragment {
  constructor(id: UUID, value: string = '') {
    super(id, DASFragmentType.HTML, [], value);
  }

  /**
   * @inheritDoc
   */
  public split(offset: number): HTMLFragment {
    return null;
  }
}

/**
 * Deserialiser function for HTML Fragments.
 *
 * @param json {any}            JSON object to deserialise
 * @returns    {HTMLFragment}   Deserialised HTML Fragment Object
 */
export function deserialiseHTMLFragment(json: any): HTMLFragment {
  return new HTMLFragment(UUID.orThrow(json.id), json.value);
}
